import styled from "styled-components"

import { FastlyImage } from "@components/FastlyImage"
import RichText from "@components/rich-text/renderer"

const Overlay = styled.div`
  background: var(--purple);
  border-radius: 16px;
  display: inline-block;
  bottom: 0;
  left: 0;
  position: absolute;
  color: var(--green);
  text-align: center;
  padding: 32px 32px 16px;

  p {
    margin-bottom: 8px !important;
  }

  > :first-child {
    font: var(--h2) !important;
  }

  > :last-child {
    color: var(--magenta);
    font: var(--text-sm) !important;
  }

  @media (max-width: 544px) {
    transform: translate(-48px, 32px) scale(0.6);
  }
`

const Image = styled(FastlyImage)`
  padding: 0 0 32px 32px;
`

const GlobalCapacity = ({ content }) => {
  // This is a transitional component, using old class names
  const [image, body, capacity] = content.section_content

  return (
    <div className="column column__ ">
      <section className="block__2-column">
        <div className="row">
          <div className="column column__saas-value-prop-2-image">
            <Image src={image.content.file.url} alt={image.content.title} />
            <Overlay>
              <RichText body={capacity.rtContent} mikan={capacity.mikan} />
            </Overlay>
          </div>
          <div className="column column__digital-publishing-or-value-prop-1-or-text">
            <RichText body={body.rtContent} mikan={body.mikan} />
          </div>
        </div>
      </section>
    </div>
  )
}

export default GlobalCapacity
